class Accordion {
  constructor($el) {
    this.$el = $el;
    this.$items = this.$el.find(".accordion__item");
    this.$triggers = this.$el.find(".accordion__trigger");

    if (!this.$el.length) return;

    this.init();
  }

  init = () => {
    this.$triggers.on("click", this.handleClick);
  };

  handleClick = (e) => {
    const $trigger = $(e.currentTarget);
    const $item = $trigger.closest(".accordion__item");
    const isOpen = $item.hasClass("is-open");

    this.$items.removeClass("is-open");
    this.$triggers.attr("aria-expanded", "false");

    if (!isOpen) {
      $item.addClass("is-open");
      $trigger.attr("aria-expanded", "true");
    }
  };
}

export default Accordion;
